import moment from "moment";
import ApiService from "@/services/api";
import { mapGetters } from "vuex";

export default {
	props: {},
	data: function() {
		return {
			//filters
			vehicleIdFilterField: "number_plate",
			showTimeFilter: false,

			startDate: null,
			endDate: null,

			showVehicleFilter: false,
			vehicles: [],
			vehiclesSelected: "",

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			itemVehicleTemplate: "<div style='height: 30px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			tagVehicleTemplate: "<div style='height: 30px; text-align: left; padding-top: 3px;'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>"
		};
	},
	watch: {
		vehiclesSelected: function(newValue) {
			this.$emit("on-filter-plate-change", this.vehiclesSelected);
		}
	},
	created() {
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		this.startDate = moment().startOf("day");
		this.endDate = moment().endOf("day");

		this.getAllVehicles();
	},

	methods: {
		applyReportFilter() {
			this.$emit("on-filter-apply-click");
		},
		resetReportFilter() {
			this.startDate = moment().startOf("day");
			this.endDate = moment().endOf("day");

			this.vehiclesSelected = "";

			this.$emit("on-filter-clean-click");
		},
		startDateChange(item) {
			this.startDate = moment(item.sender.value()).startOf("day");
			this.endDate = moment(item.sender.value()).endOf("day");

			this.timeRangeChange();
		},
		timeRangeChange() {
			this.$emit("on-filter-timerange-change", { startDate: this.startDate, endDate: this.endDate });
		},

		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate ? vehicle.number_plate : "",
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});

				self.vehicles = self._.sortBy(self.vehicles, item => {
					return item.number_plate;
				});
			});
		}
	},
	computed: {
		...mapGetters(["settings"]),
		startDateString() {
			return moment(this.startDate).format("DD MMMM YYYY");
		},
		endDateString() {
			return moment(this.endDate).format("DD MMMM YYYY");
		}
	}
};
